var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"t",rawName:"v-t",value:({ path: 'download.balloons_downloading' }),expression:"{ path: 'download.balloons_downloading' }"}]})}
var staticRenderFns = []

export { render, staticRenderFns }